import { Quote } from '../types'

export const join = (code: string) => {
  if (!code || code.length === 0) return

  const stock: Quote = cachedStocks[code]
  if (stock) {
    PubSub.publish(stock.code, stock)
  }

  if (collectCodes.find((collectCode) => collectCode === code)) return
  collectCodes = [...collectCodes, code]
}

const init = () => {
  socket = new WebSocket(process.env.REACT_APP_EXCHANGE_SERVER!)
  socket.binaryType = 'arraybuffer'

  const heartbeat = () => {
    if (!socket) return
    if (socket.readyState !== 1) return
    socket.send('PING')
    setTimeout(heartbeat, 1000 * 10)
  }

  socket.onopen = () => {
    heartbeat()
    collect()
  }

  socket.onmessage = (msg) => {
    let data = msg.data

    if (data instanceof ArrayBuffer) {
      data = String.fromCharCode.apply(null, new Uint8Array(msg.data) as any)
    }

    data = JSON.parse(data)
    cachedStocks[data.code] = Object.assign({}, data)
    PubSub.publish(data.code, data)
    PubSub.publish('list' + data.code, data)
  }

  socket.onclose = () => {
    console.log('WebSocket is closed now.')
    init()
  }
}

const collect = () => {
  setInterval(collector, 300)
}

const collector = () => {
  if (_compare(collectCodes, requestCodes)) return false
  requestCodes = collectCodes
  sendRequest()
}


const sendRequest = () => {
  socket.send(
    JSON.stringify([
      {
        type: 'recentStock',
        codes: requestCodes.map((code) => code?.replace('list', '')),
      },
      { ticket: 'icv8aut289y4g' },
    ])
  )
}

const _compare = (array1: string[], array2: string[]) => {
  return (
    array1.length === array2.length &&
    array1.sort().every(function (value, index) {
      return value === array2.sort()[index]
    })
  )
}

let socket = {} as WebSocket
let requestCodes: string[] = []
const cachedStocks: CashedStocks = {}
let collectCodes: Array<string> = []

init()

interface CashedStocks {
  [key: string]: Quote
}
